import { ValueOf } from "../type";

export const ReleaseKey = {
  ReleaseHistory: "RELEASE_HISTORY",
} as const;

export type ReleaseKeyType = ValueOf<typeof ReleaseKey>;
